import './TimeActionHeroPanelSummaryGraph'
import { Progress } from 'antd'

interface Prop {
  data: any[]
  activeTabId: any
  onTabChange: (id: string) => any
}
// { grapData, activeCard, handleChangeTab }
function TimeActionHeroPanelSummaryGraph(prop: Prop) {
  const { data, activeTabId, onTabChange } = prop

  // const checkIfSectionIsProductStatus = (section) => {
  //   return get(section, 'tasks[0].type') === 'production_status_type'
  // }

  // percent:  total late + done / totak task

  if (data && data?.length)
    return (
      <>
        {data
          .filter((i) => i.name !== 'Delivery')
          .map((item, index) => {
            // const totalTasks = item?.tasks?.length ?? 0
            // console.log('item', item)
            return (
              <li
                className="chart-component"
                key={index}
                onClick={() => onTabChange(item.id)}
              >
                <Progress
                  type="circle"
                  width={110}
                  strokeWidth={12}
                  gapPosition="right"
                  strokeLinecap="square"
                  className="test"
                  status="exception"
                  showInfo={true}
                  percent={item?.progress ? item.progress.toFixed() : 0}
                  success={{
                    percent: item?.progress ? item.progress.toFixed() : 0,
                    strokeColor:
                      item.result == 'done_overdue' ||
                      item.result == 'in_progress_overdue'
                        ? '#C03261'
                        : '#65BF73',
                  }}
                  format={() => (
                    <div>
                      <div
                        className={
                          activeTabId === item?.id
                            ? 'pr-factory-name tick'
                            : 'pr-factory-name'
                        }
                      >
                        <div className="grap-title-inter">
                          {item?.progress ? item.progress.toFixed() : 0}
                        </div>
                        <div className="grap-title-inter-percent">%</div>
                      </div>
                    </div>
                  )}
                />
                <h6
                  className={
                    'section-name-chart ' +
                    (activeTabId === item?.id ? 'tick' : 'untick')
                  }
                >
                  {item?.name}
                </h6>
                <div
                  className={activeTabId === item?.id ? 'tick' : 'untick'}
                ></div>
              </li>
            )
          })}
      </>
    )

  return <></>
}

export default TimeActionHeroPanelSummaryGraph
